'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = polyfills;
/*
 * Copyright 2016 hudl
 * All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @providesModule polyfills
 * 
 */

function customEventPolyfill() {
  function CustomEvent(event, params) {
    var inflatedParams = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, inflatedParams.bubbles, inflatedParams.cancelable, inflatedParams.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
}

// mock classList contains in IE.
// This namely fixes react-onclickoutside in IE
function svgElementClassListPolfyill() {
  if (window.SVGElement && !('classList' in window.SVGElement.prototype)) {
    Object.defineProperty(window.SVGElement.prototype, 'classList', {
      get: function get() {
        var classList = (this.getAttribute('class') || '').split(' ');
        return { contains: function contains(piece) {
            return classList.indexOf(piece) !== -1;
          } };
      }
    });
  }
}

function polyfills() {
  if (typeof window === 'undefined') {
    return;
  }

  customEventPolyfill();
  svgElementClassListPolfyill();
}
module.exports = exports['default'];